export default __webpack_public_path__ + "static/media/customer-signup@2x.44e390da.png";